import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IPostVideoCategoryRequest } from '../models/requestModels'
import { IVideoCategory } from '../models/responseModels'

export class PostVideoCategoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/video-category/post',
      requesterInfo,
    })
  }

  public async postVideoCategory(request: IPostVideoCategoryRequest): Promise<IVideoCategory> {
    return await this.postAsync<IVideoCategory>(request)
  }
}
